import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

/** localStorage that never throws (private windows, blocked storage). For per-viewer conveniences only. */
export const safeStorage = {
  get<T>(key: string, fallback: T): T {
    try {
      const raw = globalThis.localStorage?.getItem(key)
      return raw ? (JSON.parse(raw) as T) : fallback
    } catch {
      return fallback
    }
  },
  set(key: string, value: unknown): void {
    try {
      globalThis.localStorage?.setItem(key, JSON.stringify(value))
    } catch {
      // storage unavailable: preference is simply not remembered
    }
  },
  remove(key: string): void {
    try {
      globalThis.localStorage?.removeItem(key)
    } catch {
      // ignore
    }
  },
}
